/**
 * Recharge Cart Enhancements
 * 
 * 1. Injects custom HTML into the Recharge cart drawer when a specific product is in the cart
 * 2. Fixes overlay persistence bug when closing the Recharge cart drawer
 *
 * @version 1.1.0
 * @author Mood Co
 */

(function() {
  'use strict';

  // Configuration — products that trigger custom HTML in the Recharge cart drawer
  // Add entries: { variantId: '...', productId: '...', html: '...' }
  const CART_INJECTIONS = [
    {
      variantId: '55520075743612',
      productId: '15427587604860',
      html: `
        <div class="rc-cart-custom-notice" style="
          background: #f0f2ef;
          border: 1px solid #d2dbd3;
          border-radius: 8px;
          padding: 12px 16px;
          margin: 8px 16px;
          font-size: 14px;
          line-height: 1.5;
          color: #444;
        ">
          <p style="margin: 0; font-weight: 600;">Skin Purity Tea Is Currently Out Of Stock</p>
          <p style="margin: 4px 0 0;">Your full order will be shipped within the next 2 weeks, once Skin Purity Tea is available again.</p>
        </div>
      `
    }
  ];

  const DRAWER_ID = 'recharge-storefront-experiences__cart-drawer';
  const INJECTION_MARKER = 'data-mood-injected';

  let drawerSetUp = false;
  let injectionInProgress = false;

  /**
   * Fetch current cart contents
   */
  async function getCartItems() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      return cart.items || [];
    } catch (e) {
      return [];
    }
  }

  /**
   * Check cart and inject or remove notices as needed
   */
  async function recheckCartNotices(shadowRoot) {
    const cartItems = await getCartItems();
    const cartVariantIds = cartItems.map(item => String(item.variant_id));
    const cartProductIds = cartItems.map(item => String(item.product_id));

    for (const injection of CART_INJECTIONS) {
      const match = cartVariantIds.includes(injection.variantId) ||
                    (injection.productId && cartProductIds.includes(injection.productId));
      const existing = shadowRoot.querySelector(`[${INJECTION_MARKER}="${injection.variantId}"]`);

      if (match && !existing && !injectionInProgress) {
        injectionInProgress = true;
        const header = shadowRoot.querySelector('header');
        if (header) {
          const container = document.createElement('div');
          container.setAttribute(INJECTION_MARKER, injection.variantId);
          container.innerHTML = injection.html;
          header.after(container);
        }
      } else if (!match && existing) {
        existing.remove();
        injectionInProgress = false;
      }
    }
  }

  /**
   * Clean up lingering overlay when the Recharge drawer closes
   */
  function fixOverlayOnClose(shadowRoot) {
    const observer = new MutationObserver(() => {
      const overlayDiv = shadowRoot.querySelector('[data-state="closed"][class*="bg-black"]');
      if (overlayDiv) {
        setTimeout(() => {
          const stillClosed = shadowRoot.querySelector('[data-state="closed"][class*="bg-black"]');
          if (stillClosed) {
            stillClosed.style.pointerEvents = 'none';
            stillClosed.style.opacity = '0';
          }
        }, 400);
      }

      if (!shadowRoot.querySelector('[role="dialog"]')) {
        document.body.style.overflow = '';
        document.body.style.pointerEvents = '';
        shadowRoot.querySelectorAll(`[${INJECTION_MARKER}]`).forEach(el => el.remove());
        injectionInProgress = false;
      }
    });

    observer.observe(shadowRoot, { childList: true, subtree: true, attributes: true });
  }

  /**
   * Watch for the Recharge cart drawer and set up enhancements
   */
  function watchForDrawer() {
    const drawerEl = document.getElementById(DRAWER_ID);
    if (drawerEl && drawerEl.shadowRoot) {
      setupDrawer(drawerEl.shadowRoot);
      return;
    }

    const bodyObserver = new MutationObserver(() => {
      const el = document.getElementById(DRAWER_ID);
      if (el && el.shadowRoot) {
        setupDrawer(el.shadowRoot);
      }
    });

    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  function setupDrawer(shadowRoot) {
    if (drawerSetUp) return;
    drawerSetUp = true;

    fixOverlayOnClose(shadowRoot);

    const drawerObserver = new MutationObserver(() => {
      if (shadowRoot.querySelector('[role="dialog"]')) {
        recheckCartNotices(shadowRoot);
      }
    });

    drawerObserver.observe(shadowRoot, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForDrawer);
  } else {
    watchForDrawer();
  }
})();
